<template>
	<router-link :to="{ name: 'watchlistDetail', params: {id: watchlist.uid, watchlist: watchlist}}">
		<watchlist-teaser :watchlist="watchlist"/>
	</router-link>
</template>

<script>
	import WatchlistTeaser from "@/components/watchlist/WatchlistTeaser";

	export default {
		name: "WatchlistLink",
		props: ['watchlist'],
		components: {WatchlistTeaser}
	}
</script>

<style scoped>

</style>